export const formatAmount = (value: number, country?: string): string => {
  const locale = country ? (country.toUpperCase() === "MALAYSIA" ? "en-MY" : "en-SG") : "en-US";

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: country ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const roundToTwo = (value: number) => Math.round((value + Number.EPSILON) * 100) / 100;
